import React from "react";
import { Link } from "react-router-dom";
import "../styles/root.css";
import { useLocale } from "../context/LocaleContext";
import Logo from "../assets/images/anisija/anisija-logo.svg";

function Footer() {
  const currentYear = new Date().getFullYear();
  const { t } = useLocale();

  return (
    <footer className="footer">
      <div className="footer-accent-bar" />
      <div className="footer-inner">
        <div className="footer-top">
          <div className="footer-brand">
            <Link to="/" className="footer-brand-link">
              <img className="footer-logo" src={Logo} alt="Anisija" />
              <div className="footer-brand-text">
                <span className="footer-brand-name">Anisija</span>
                <span className="footer-brand-tagline">{t.nav.tagline}</span>
              </div>
            </Link>
          </div>

          <nav className="footer-nav">
            <div className="footer-nav-group">
              <h3 className="footer-nav-heading">{t.nav.documents}</h3>
              <ul className="footer-nav-list">
                <li>
                  <Link to="/documents/annual-reports">{t.nav.annualReports}</Link>
                </li>
                <li>
                  <Link to="/documents/projects">{t.nav.projects}</Link>
                </li>
              </ul>
            </div>

            <div className="footer-nav-group">
              <h3 className="footer-nav-heading">{t.footer.heading}</h3>
              <ul className="footer-nav-list">
                <li>
                  <a href="mailto:anisijainfo@gmail.com">anisijainfo@gmail.com</a>
                </li>
                <li>
                  <a href="tel:+38978831731">+389 78 831 731</a>
                </li>
                <li>
                  <a
                    href="https://www.facebook.com/anisijazkso"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Facebook
                  </a>
                </li>
              </ul>
            </div>

            <div className="footer-nav-group">
              <h3 className="footer-nav-heading">{t.nav.about}</h3>
              <ul className="footer-nav-list">
                <li>
                  <Link to="/about">{t.about.headline}</Link>
                </li>
                <li>
                  <Link to="/news">{t.nav.news}</Link>
                </li>
              </ul>
            </div>
          </nav>
        </div>

        <div className="footer-bottom">
          <p className="footer-copy">
            &copy; {currentYear} Anisija. {t.footer.rights}
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
